
import { useState, useEffect, useContext } from "react";
import { getToken } from "../services/auth";
import CountDeliveryAndTable from "../services/countDeliveryAndTable";
import audioPedido from '../assets/audio/audio-pedido.mp3'
import logoTutorial from '../assets/logoTutorial.svg';
import { deliveryProviderContext } from "../contexts/delivery";
import { SocketDeliveryContext } from "../contexts/socketDelivery";

let notification;
let audio;
export const useCountDelivery = () => {
    const {emitSocket, listenSocket, closeSocket} = useContext(SocketDeliveryContext)
    const [coutDelivery, setCoutDelivery] = useState(0);
    const [audioEnabled, setAudioEnabled] = useState(false); 
    const {listInProgressOrder} = useContext(deliveryProviderContext)
    const newDelivery = listInProgressOrder?.length >= 0 ? listInProgressOrder.filter(item => item.istatus === 1)?.length > 0 ? true : false : false

    // useEffect(() => {
    //     if(newDelivery) NotificationDelivery()
    // }, [newDelivery])
    

    const getCountDelivery = async () => {
        try {
            const cnpj = getToken('CNPJ');
            const service = new CountDeliveryAndTable();
            const result = await service.getCountDelivery({
                cnpj
            })

            if (result.success) {
                setCoutDelivery(parseInt(result.data[0].qtd))
                emitSocket('count', {
                    id: getToken('CNPJ'),
                    count: result.data[0].qtd
                })
            }
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {

        if(window.location.pathname !== '/')getCountDelivery()

    },[getToken('CNPJ')]) 


    useEffect(() => {
        listenSocket('count', (data) => {
            if(data?.data?.origem === 'cardapio') return setCoutDelivery(state => (parseInt(state) + parseInt(data?.data?.count)))
            if(data?.data?.count >= 0 ) setCoutDelivery(parseInt(data?.data?.count))
        })
        
        return () => closeSocket('count')
    }, [])



        // 🔊 função para desbloquear áudio na primeira interação
    const enableAudio = async () => {
        audio = new Audio(audioPedido);
        audio.loop = false;
        audio.muted = false;
        try {
            await audio.play(); // roda 1 vez para liberar
            audio.pause();
            audioEnabled = true; // agora podemos tocar áudio normalmente
            console.log("🔊 Áudio de notificação ativado!");
        } catch (err) {
            console.warn("⚠️ Usuário precisa interagir para liberar o som", err);
        }
    };

    // 🔔 função adaptada de NotificationDelivery
    const NotificationDelivery = async() => {
        const permission = await Notification.requestPermission();
        if(permission !== 'granted') return;

        notification = new Notification('Delivery', {
            body:'Novo Pedido!',
            renotify:false,
            requireInteraction: false,
            icon:logoTutorial,
        });

        // só toca áudio se já tiver sido desbloqueado
        if(audioEnabled) {
            audio = new Audio(audioPedido);
            audio.loop = true;
            audio.muted = false;
            audio.play().catch(() => {});
        }

        notification.onclick = () => {
            audio?.pause();
            window.open('https://sistefood.com.br/Delivery', '_blank');
        };

        notification.onclose = () => {
            audio?.pause();
        };
    }


    // const NotificationDelivery = async() => {
    //     try {
    //         let granted = false;
    //         const permission =  await Notification.requestPermission();
    //         granted = permission === 'granted' ? true : false;
    //         if (granted) {
    //             notification = new Notification('Delivery', {
    //                 body:'Novo Pedido!',
    //                 renotify:false,
    //                 requireInteraction: false,
    //                 icon:logoTutorial,
    
                
    //             })
    //             audio = new Audio(audioPedido);
    //             audio.loop = true;
    //             audio.muted = false;
    //             audio.play();
                
    //             notification.onclick = (event) =>  {
    //                 event.preventDefault();
    //                 audio.loop = false;
    //                 audio.pause();
    //                 notification.addEventListener('click', window.open('https://sistefood.com.br/Delivery', 'https://sistefood.com.br/Delivery'));
            
    //             }
    
    //             notification.onclose = (event) =>  {
    //                 event.preventDefault();
    //                 audio.pause();
    //             }
    
    //         }
            
    //     } catch (error) {
    //     }
    // }

    return {coutDelivery}
}
